import { axios } from '@/lib/axios'
import { useQuery } from '@tanstack/react-query'

export const getECCNs = async (query) => {
  const { page, pageSize, sortBy = '', orderBy = 1, filters = {} } = query

  const transformedFilters = { ...filters }
  Object.keys(transformedFilters).forEach((key) => {
    if (Array.isArray(transformedFilters[key])) {
      transformedFilters[key] = transformedFilters[key].join(',')
    }
  })

  const params = {
    page,
    limit: pageSize,
    sortBy,
    orderBy,
    ...transformedFilters,
  }
  const response = await axios.get('/ECCNs', { params })
  return response.data
}

const useECCN = () => {
  const useFetchECCNs = (query) => {
    return useQuery({
      queryKey: ['ECCNs', query],
      queryFn: () => getECCNs(query),
      keepPreviousData: true,
    })
  }

  return {
    useFetchECCNs,
  }
}

export default useECCN
